/**
 * @desc 分页
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(
  params: API.business.customerOrderStatementManagement.page.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/customerOrderStatementManagement/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
